import { TextSortBy } from "nystem-components";

const ReferenceSortBy = (props) => <TextSortBy {...props} />;
export default ReferenceSortBy;
